// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RadiusUpleftOutlinedSvg from "@fishx/icons-svg/es/asn/RadiusUpleftOutlined";
import FishxIcon from '../components/FishxIcon';

var RadiusUpleftOutlined = function RadiusUpleftOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: RadiusUpleftOutlinedSvg
  }));
};

RadiusUpleftOutlined.displayName = 'RadiusUpleftOutlined';
export default React.forwardRef(RadiusUpleftOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/RadiusUpleftOutlined.js
// module id = 3970
// module chunks = 0